module.exports = __webpack_public_path__ + "static/img/28-1.73146ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/28-1.jpg
// module id = 79WK
// module chunks = 0